// components/ModalApproval.js
import React from 'react';
import styled from 'styled-components';

const ModalBackdrop = styled.div`
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const ModalContent = styled.div`
    background-color: white;
    padding: 2rem;
    border-radius: 8px;
    max-width: 400px;
    text-align: center;
    box-shadow: 0 5px 15px rgba(0,0,0,0.3);
`;

const ModalApproval = ({ onClose }) => {
    return (
        <ModalBackdrop onClick={onClose}>
            <ModalContent onClick={e => e.stopPropagation()}>
                <h2>Registro exitoso</h2>
                <p>Tu cuenta ha sido creada y está pendiente de aprobación.</p>
                <p>Recibirás un correo electrónico cuando sea aprobada.</p>
                <button onClick={onClose}>Cerrar</button>
            </ModalContent>
        </ModalBackdrop>
    );
};

export default ModalApproval;
